import {
  bancoDoBrasilIcon,
  // banrisulIcon,
  bradescoIcon,
  brbIcon,
  caixaEconomicaIcon,
  itauIcon,
  santanderIcon,
  sicoobIcon,
} from "assets/images/banks";

export const bancos = [
  {
    code: "341",
    icone: itauIcon,
    mensagem:
      "Nos próximos dias, você receberá um e-mail e/ou SMS com a confirmação que tudo deu certo. Enquanto isso não ocorrer, o pagamento de sua fatura deve ser realizado via  boleto.",
  },
  {
    code: "104",
    icone: caixaEconomicaIcon,
    mensagem:
      "<p>Fique de olho nos próximos passos:</p><ul><li>Para finalizar a adesão ao débito automático é necessário acessar o canal digital do banco ou caixa eletrônico para <b>aprovar</b> essa solicitação que estará disponível em até dois dias úteis. <b>Só após essa confirmação o cadastro estará concluído.</b></li><li>Você tem o prazo de até 180 dias para aprovar essa solicitação junto com a sua instuição financeira.</li><li>Enquanto isso não ocorrer, o pagamento da sua fatura deve <b>continuar sendo feito via boleto.</b></li></ul>",
  },
  {
    code: "033",
    icone: santanderIcon,
    mensagem:
      "Nos próximos dias, você receberá um e-mail e/ou SMS com a confirmação que tudo deu certo. Enquanto isso não ocorrer, o pagamento de sua fatura deve ser realizado via  boleto.",
  },
  {
    code: "237",
    icone: bradescoIcon,
    mensagem:
      "Nos próximos dias, você receberá um e-mail e/ou SMS com a confirmação que tudo deu certo. Enquanto isso não ocorrer, o pagamento de sua fatura deve ser realizado via  boleto.",
  },
  {
    code: "001",
    icone: bancoDoBrasilIcon,
    mensagem:
      "<p>Fique de olho nos próximos passos:</p><ul><li>Para finalizar a adesão ao débito automático é necessário acessar o canal digital do banco ou caixa eletrônico para <b>aprovar</b> essa solicitação que estará disponível em até dois dias úteis. <b>Só após essa confirmação o cadastro estará concluído.</b></li><li>Você tem o prazo de até 180 dias para aprovar essa solicitação junto com a sua instuição financeira.</li><li>Enquanto isso não ocorrer, o pagamento da sua fatura deve <b>continuar sendo feito via boleto.</b></li></ul>",
  },
  {
    code: "070",
    icone: brbIcon,
    mensagem:
      "Nos próximos dias, você receberá um e-mail e/ou SMS com a confirmação que tudo deu certo. Enquanto isso não ocorrer, o pagamento de sua fatura deve ser realizado via  boleto.",
  },
  {
    code: "756",
    icone: sicoobIcon,
    mensagem:
      "Nos próximos dias, você receberá um e-mail e/ou SMS com a confirmação que tudo deu certo. Enquanto isso não ocorrer, o pagamento de sua fatura deve ser realizado via  boleto.",
  },
  {
    code: "748",
    icone: sicoobIcon,
    mensagem:
      "Nos próximos dias, você receberá um e-mail e/ou SMS com a confirmação que tudo deu certo. Enquanto isso não ocorrer, o pagamento de sua fatura deve ser realizado via  boleto.",
  },
];
